import { Link } from 'react-router-dom';
import { Box, Flex, HStack, useColorModeValue, Image } from '@chakra-ui/react';
import Logo from '../img/logo/LOGO.png';
const Links = [
  { page: '', title: 'الصفحة الرئيسية' },

  { page: 'translete-main', title: ' قطاع الترجمة' },
  { page: 'library', title: ' مكتبتنا' },
];

const NavLink = ({ page, title }) => (
  <Link px={2} py={1} rounded={'md'} to={`/${page}`}>
    {title}
  </Link>
);

export default function Simple() {
  return (
    <>
      <Box px={4}>
        <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
          <HStack as={'nav'} spacing={9} display={{ base: 'none', md: 'flex' }}>
            {/* {Links.map(link => (
              <NavLink page={link.page} title={link.title} />
            ))} */}
          </HStack>
          <HStack spacing={8} alignItems={'center'}>
            <Box>
              <Image
                boxSize="100px"
                objectFit="cover"
                src={Logo}
                alt="LOGO"
                mr={5}
                mt={90}
              />
            </Box>
          </HStack>
        </Flex>
      </Box>
    </>
  );
}
